import { RenderStage } from '@mutiny-pkg/champaign-schemas/src/schemas/micrositePages/render';
import { buildRuntimeShimPath, buildRuntimeShimUrl } from '@mutiny-pkg/bin-ui/src/customComponents/runtimeShimUrl';

type CustomComponentAssetUrlResolverInput = {
  renderStage: RenderStage;
  staticSiteDomain: string | null;
  getPageOrigin: () => string;
};

export function createCustomComponentAssetUrlResolvers({
  renderStage,
  staticSiteDomain,
  getPageOrigin,
}: CustomComponentAssetUrlResolverInput) {
  if (renderStage === RenderStage.Publish) {
    return {
      resolveCompiledUrl: (sourceHash: string) => new URL(`/assets/${sourceHash}.js`, getPageOrigin()).toString(),
      resolveRuntimeUrl: (specifier: string) => new URL(buildRuntimeShimPath(specifier), getPageOrigin()).toString(),
    };
  }

  return {
    resolveCompiledUrl: (sourceHash: string) => `https://${staticSiteDomain}/assets/${sourceHash}.js`,
    resolveRuntimeUrl: (specifier: string) => buildRuntimeShimUrl(staticSiteDomain, specifier),
  };
}
